

















import { Vue, Component } from "vue-property-decorator";
import MainMenu from "@/views/MainMenu.vue";
@Component({
  components: {
    MainMenu,
  },
})
export default class App extends Vue {
  private isCollapse = false;
}
